import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: "mountFormat"
})

export class MountFormatPipe implements PipeTransform {
  transform(value: string): string { 
      debugger;
    return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}
